export * from './TextQuoteAIcon';
export * from './TextQuoteAIcon16Light';
export * from './TextQuoteAIcon16Regular';
export * from './TextQuoteAIcon16Solid';
export * from './TextQuoteAIcon20Light';
export * from './TextQuoteAIcon20Regular';
export * from './TextQuoteAIcon20Solid';
export * from './TextQuoteAIcon24Regular';
export * from './TextQuoteAIcon24Solid';
export * from './TextQuoteAIcon32Regular';
export * from './TextQuoteAIcon64Regular';
